import { Box, Stack, useTheme } from '@mui/material';
import { Heading } from '../../components/Heading/Heading';
import { useWindowSize } from '../../hooks/useWindowSize/useWindowSize';
import { containerSx } from '../../styles/Global.style';
import { formContentSx, formTitleSx } from './FormContainer.style';

export const FormContainer = ({ children, title }) => {
  const theme = useTheme();
  const { windowSize } = useWindowSize();
  const height = windowSize.appInnerHeight;

  return (
    <Stack component="section" sx={containerSx(height)}>
      <Box sx={formContentSx}>
        <Heading text={title} level={1} sx={formTitleSx(theme)} />
        {children}
      </Box>
    </Stack>
  );
};
